import { render, staticRenderFns } from "./Item3.vue?vue&type=template&id=f33217bc&scoped=true&"
import script from "./Item3.vue?vue&type=script&lang=js&"
export * from "./Item3.vue?vue&type=script&lang=js&"
import style0 from "./Item3.vue?vue&type=style&index=0&id=f33217bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33217bc",
  null
  
)

export default component.exports